import React, { useEffect } from "react";
import styles from '../Form.module.css'
import RadioSelect from "../inputs/RadioSelect";
import {BsFillCheckCircleFill} from 'react-icons/bs'

function Step3({ formData, setFormData,setNextButtonState }) {


  
    
    
    
    useEffect(() => {
     
    
      setNextButtonState(formData.presenceAttentionInClassLast10Days!==''
      && formData.stateWhileAskingQuestions!==''&&
      formData.sleepHours!=='')
    
    
    }, [formData]);
    

  return (

    <div>
      <div className={styles.header}>
          <h1>We're getting to know you</h1>
        </div>

    <div className={styles.subFormContainer}>
    



<div className={styles.singleFormInputContainer}>

  <div className={styles.checkedInput}
    style={{color:formData.sleepHours===''?'transparent':'rgb(0, 123, 250)'}}><BsFillCheckCircleFill/></div>
          <div className={styles.singleFormInput}>
          <div className={styles.singleInputTitle}>
How many hours do you usually sleep?
          </div>
    <RadioSelect

onChange={(data) =>
  setFormData({ ...formData, sleepHours: data })
}

value={formData.sleepHours}
options={[
{ value: '<5', component: <div>0-5 hrs</div> },
{ value: '5-7', component: <div>5-7 hrs</div> },
{ value: '7-9', component: <div>7-9 hrs</div> },
{ value: '9+', component: <div>9+ hrs</div> },]}

selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
/>
</div>
</div>


<div className={styles.singleFormInputContainer}>

  <div className={styles.checkedInput}
    style={{color:formData.presenceAttentionInClassLast10Days===''?'transparent':'rgb(0, 123, 250)'}}><BsFillCheckCircleFill/></div>
<div className={styles.singleFormInput}>
          <div className={styles.singleInputTitle}>
How do you describe your activity during the lessons in general?
          </div>
<RadioSelect

onChange={(data) =>
  setFormData({ ...formData, presenceAttentionInClassLast10Days: data })
}

value={formData.presenceAttentionInClassLast10Days}
options={[
{ value: '-1', component: <div>Not Active At All</div> },
{ value: '0', component: <div>Slightly Active</div> },
{ value: '1', component: <div>Active</div> },
{ value: '2', component: <div>Very Active</div> }]}

selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
/>

</div>
</div>


<div className={styles.singleFormInputContainer}>

  <div className={styles.checkedInput}
    style={{color:formData.stateWhileAskingQuestions===''?'transparent':'rgb(0, 123, 250)'}}><BsFillCheckCircleFill/></div>
<div className={styles.singleFormInput}>
          <div className={styles.singleInputTitle}>
How do you feel when asking a question in class?
          </div>
<RadioSelect

onChange={(data) =>
  setFormData({ ...formData, stateWhileAskingQuestions: data })
}

value={formData.stateWhileAskingQuestions}
options={[
{ value: '-2', component: <div>Very Nerveous</div> },
{ value: '-1', component: <div>Nerveous</div> },
{ value: '0', component: <div>Indifferent</div> },
{ value: '1', component: <div>Excited</div> },
{ value: '2', component: <div>Very Excited</div> }]}

selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
/>
</div>

</div>

  
    </div>
    </div>
  );
}

export default Step3;
